import Set from './set.entity';
import { SosListResponse } from '../sos-response';
import { EpisodicBaseESDoc } from '../types';

export interface SetESDoc extends EpisodicBaseESDoc {
	name: string;
}

export interface SetListResponse extends SosListResponse {
	listed: {
		Set: Set[];
	};
}
